(function() {
  function initColorSync() {
    const productData = document.querySelector('[data-section-type="static-product"][data-section-data]');
    if (!productData) {
      console.log('[color-sync] No product data section found');
      return;
    }
    let productJSON;
    try { productJSON = JSON.parse(productData.textContent).product; } catch(e) {
      console.log('[color-sync] Failed to parse product JSON:', e);
      return;
    }

    // Build map: color name (lowercase) -> image_id
    const colorToImage = {};
    (productJSON.variants || []).forEach(function(v) {
      if (v.option2 && v.image_id) {
        const key = v.option2.toLowerCase().trim();
        if (!colorToImage[key]) colorToImage[key] = v.image_id;
      }
    });
    console.log('[color-sync] Color map:', colorToImage);

    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) {
      console.log('[color-sync] No gallery found');
      return;
    }

    // Strategy 1: Listen on VARIANT-SELECTION attribute changes
    const variantSelection = document.querySelector('[data-variant-selection]');
    if (variantSelection) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'variant') {
            const val = variantSelection.getAttribute('variant');
            console.log('[color-sync] variant attr changed to:', val);
            if (val && val !== 'not-selected') {
              const variantId = parseInt(val);
              const tv = (productJSON.variants || []).find(function(v) { return v.id === variantId; });
              if (tv && tv.option2) {
                switchGallery(tv.option2.toLowerCase().trim(), colorToImage, gallery);
              }
            }
          }
        });
      });
      observer.observe(variantSelection, { attributes: true });
    }

    // Strategy 2: Direct click on color option values (index 1)
    const colorValues = document.querySelectorAll('[data-variant-option-value-wrapper]');
    colorValues.forEach(function(wrapper) {
      const input = wrapper.querySelector('input[data-variant-option-value]');
      if (input && input.getAttribute('data-variant-option-value-index') === '1') {
        const label = wrapper.querySelector('label');
        if (label) {
          label.addEventListener('click', function() {
            setTimeout(function() {
              const colorName = input.value.toLowerCase().trim();
              console.log('[color-sync] Color swatch clicked:', colorName);
              switchGallery(colorName, colorToImage, gallery);
            }, 200);
          });
        }
      }
    });

    console.log('[color-sync] Initialized successfully');
  }

  function switchGallery(colorKey, colorToImage, gallery) {
    const imageId = colorToImage[colorKey];
    if (!imageId) {
      console.log('[color-sync] No image for color key:', colorKey);
      return;
    }

    const mediaSlide = gallery.querySelector('[data-media="' + imageId + '"]');
    if (!mediaSlide) {
      console.log('[color-sync] No media slide for image:', imageId, 'slides:', gallery.querySelectorAll('[data-media]').length);
      return;
    }

    console.log('[color-sync] Switching gallery to image', imageId);
    mediaSlide.click();
  }

  // Retry init if DOM not ready
  function safeInit() {
    if (document.querySelector('[data-variant-selection]') && document.querySelector('[data-section-type="static-product"]')) {
      initColorSync();
    } else {
      console.log('[color-sync] Retrying init...');
      setTimeout(safeInit, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();